function setTag(el, groupId){
  event.preventDefault();
  var button = document.querySelector(".tag.active")
  button.classList.remove('active');
  el.parentElement.classList.add('active');
  var oldGroup = document.querySelector(".accordian-group:not(.hidden)");
  oldGroup.classList.add("hidden");
  var newGroup = document.querySelector(`.accordian-group#${groupId}`);
  newGroup.classList.remove('hidden');
}

function setFilter(el, dataSet){
  event.preventDefault();
  var button = document.querySelector(".tag.active")
  button.classList.remove('active');
  el.parentElement.classList.add('active');
  var oldGroups = document.querySelectorAll(".team-member:not(.hidden)");
  oldGroups.forEach(function(oldGroup){
    oldGroup.classList.add("hidden");
  });
  var newGroups = document.querySelectorAll(".team-member[data-" + dataSet + "='true']");
  newGroups.forEach(function(newGroup){
    newGroup.classList.remove('hidden');
  });
}